
export class EscalaEvaluacion {
    escalaevaluacionid: number = 0;
    nombre: string = "";
    activo: boolean = true;
    opciones: any[] = []

    constructor(init?: Partial<EscalaEvaluacion>) {
        Object.assign(this, init);
    }
}
